import type { ReactNode } from 'react';
import { styled } from '@mui/material/styles';

const StyledPlaceholder = styled('div')({
  fontSize: '15px',
  color: '#999',
  overflow: 'hidden',
  position: 'absolute',
  textOverflow: 'ellipsis',
  top: '22px',
  left: '24px',
  right: '28px',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  pointerEvents: 'none',
});

export const LexicalPlaceholder = ({ children }: { children: ReactNode }): JSX.Element => {
  return <StyledPlaceholder>{children}</StyledPlaceholder>;
};
